import { Location } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'editable-field',
  templateUrl: './editable-field.component.html',
  styleUrls: ['./editable-field.component.scss']
})
export class EditableFieldComponent {
  @Input() customContent: string = '';
  @Input() showCustomContent: boolean = true;
  @Input() target: '_self' | '_blank' = '_self';
  @Output() onClick = new EventEmitter<EditableFieldComponent>();
  @Input() href: string = '';
  @Input() linkDisabled: boolean = false;
  @Output() onBlur = new EventEmitter<void>();
  @Input() disabled: boolean = false;

  isDialogOpen = false;
  dialogPosition = { top: 0, left: 0 };

  constructor(
    private elementRef: ElementRef,
    private router: Router,
    private location: Location
  ) {}

  handleClick(event: MouseEvent): void {
    if (this.disabled) return;
    if (this.showCustomContent) {
      this.openDialog(event);
    }
    this.onClick.emit(this);
  }

  handleContentClick(event: MouseEvent): void {
    if (this.disabled) return;
    if (!this.href || this.linkDisabled) return this.handleClick(event);
    if (this.target === '_blank') {
      const url = this.location.prepareExternalUrl(this.href);
      window.open(url, '_blank');
    } else {
      this.router.navigate([this.href]);
    }
  }

  openDialog(event: MouseEvent): void {
    this.isDialogOpen = true;

    // Calcul de la position du dialog
    const rect = (event.target as HTMLElement).getBoundingClientRect();
    this.dialogPosition = {
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX
    };

    // Focus le dialog après l'ouverture pour gérer les événements clavier
    setTimeout(() => {
      this.focusFirstInput();
    });
  }

  focusFirstInput(): void {
    var dialog = this.elementRef.nativeElement.querySelector('#dialog');
    if (dialog) {
      const inputs = dialog.querySelectorAll('input[type="text"], input[type="number"]');
      if (inputs.length > 0) {
        const firstInput = inputs[0] as HTMLInputElement;
        setTimeout(() => {
          firstInput.focus();
          firstInput.select();
        }, 50);
      }

      // Add an event listener to the host element
      document.addEventListener('click', (event) => this.onDocumentClick(event));
      document.addEventListener('keydown', (event) => this.onKeyDown(event));
    }
  }

  closeDialog(): void {
    try {
      document.removeEventListener('click', (event) => this.onDocumentClick(event));
      document.removeEventListener('keydown', (event) => this.onKeyDown(event));
    } catch (error) {}

    if (this.isDialogOpen) {
      this.isDialogOpen = false;
      this.onBlur.emit();
    }
  }

  onDocumentClick(event: any): void {
    var dialog = this.elementRef.nativeElement.querySelector('#dialog');
    var wrapper = this.elementRef.nativeElement.querySelector('#wrapper');
    if (this.isDialogOpen && dialog && wrapper) {
      // Ferme le dialog si le clic est en dehors du wrapper ET du dialog
      if (!wrapper.contains(event.target) && !dialog.contains(event.target)) {
        this.closeDialog();
      }
    }
  }

  onKeyDown(event: any): void {
    if ((event.key === 'Enter' || event.key === 'Escape') && this.isDialogOpen) {
      event.preventDefault();
      this.closeDialog();
    }
  }
}
